import React, { useEffect, useState } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import authSecurity from '../utils/authSecurity';
import { LoadingWithText } from './LoadingSpinner';


const ProtectedRoute = ({ children }) => {
  const [isValidating, setIsValidating] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const userType = localStorage.getItem('userType');

  useEffect(() => {
    const checkAuth = () => {
      const isValid = authSecurity.isValidSession();
      setIsAuthenticated(isValid);
      if (isValid) {
        authSecurity.updateActivity();
        // Check user type against path
        if (location.pathname.startsWith('/dashboard/clinic') && userType !== 'clinic') {
          navigate('/dashboard/user');
        } else if (location.pathname.startsWith('/dashboard/user') && userType !== 'user') {
          navigate('/dashboard/clinic');
        }
      }
      setIsValidating(false);
    };

    checkAuth();
  }, [location.pathname, navigate, userType]);

  if (isValidating) {
    return <LoadingWithText text="جاري التحقق من الجلسة..." />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
};

export default ProtectedRoute;